<template>
  <div class="table">
    <br />
    <!-- <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <b>运价设置</b>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <br />
    <div class="container">
      <div class="form-box">
        <el-form ref="form" :model="form" :rules="rules" style="width: 1500px;" label-width="200px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运价地区:" prop="selectedOptions">
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="form.selectedOptions"
                  @change="handleChange"
                  filterable
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="运价业务类型:" style="margin-left: 30px;" prop="businessType">
                <el-select v-model="form.businessType" placeholder="请选择" ref="businessType">
                  <el-option
                    v-for="item in businessTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="运价适用车型:" style="margin-left: 30px;" prop="vehicleType">
                <el-select v-model="form.vehicleType" placeholder="请选择" ref="vehicleType">
                  <el-option
                    v-for="item in options3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="起步价(元):" prop="startFare">
                <el-input v-model="form.startFare" placeholder="起步价" ref="startFare"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="起步里程(km):" prop="startMile">
                <el-input v-model="form.startMile" placeholder="起步里程(km)" ref="startMile"></el-input>
              </el-form-item>
            </el-col>
          <el-col :span="6">
              <el-form-item label="起步时间(分钟):" prop="startMin">
                <el-input v-model="form.startMin" placeholder="起步时间(分钟)" ref="startMin"></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>

          <el-row>
           
            <el-col :span="6">
              <el-form-item label="计程单价(元):" style="margin-left: 30px;" prop="pricePerMile">
                <el-input v-model="form.pricePerMile" placeholder="计程单价(元)" ref="pricePerMile"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计时单价(元):" style="margin-left: 30px;" prop="pricePerMin">
                <el-input v-model="form.pricePerMin" placeholder="计时单价(元)" ref="pricePerMin"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="单程加价单价(元):" prop="increasePrice">
                <el-input v-model="form.increasePrice" placeholder="单程加价单价(元)" ref="increasePrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单程加价公里(km):" style="margin-left: 30px;" prop="increasePriceMile">
                <el-input
                  v-model="form.increasePriceMile"
                  placeholder="单程加价公里(km)"
                  ref="increasePriceMile"
                ></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
          <br />
          <el-col :span="24">
            <el-button style="margin-left: 400px;" type="primary" @click="submitForm('form')">确认设置</el-button>
            <el-button
              style="margin-left: 10px;"
              type="success"
              @click="resetForm('form')"
              icon="el-icon-refresh"
            >重置</el-button>
            <!-- <el-button style="margin-left: 20px;" type="primary"  class="handle-del mr10" @click="downloadExcel">批量导出</el-button> -->
          <!-- </el-col>
        </el-form> -->
      <!-- </div> -->
    <!-- </div>  -->
  </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from "element-china-area-data";

import store from "../../store";

export default {
  name: "basetable",
  data() {
    return {
      options: regionData,
      areaCode: "",
      form: {
        selectedOptions: [],
        businessType: "",
        vehicleType: "",
        startFare: "",
        startMile: "",
        pricePerMile: "",
        pricePerMin: "",
        increasePrice: "",
        increasePriceMile: "",
        startMin: ""
      },
      businessTypes: [],
      value: "",
      options3: [
        {
          value: "1",
          label: "经济快车"
        },
        {
          value: "2",
          label: "舒适"
        },
        {
          value: "3",
          label: "商务"
        },
        {
          value: "4",
          label: "豪华"
        },
        {
          value: "5",
          label: "出租车"
        }
      ],
      rules: {
        selectedOptions: [
          {
            required: true,
            message: "请选择运价地址",
            trigger: "blur"
          }
        ],
        businessType: [
          {
            required: true,
            message: "请选择运价业务类型",
            trigger: "blur"
          }
        ],
        vehicleType: [
          {
            required: true,
            message: "请选择运价适用车型",
            trigger: "blur"
          }
        ],
        startFare: [
          {
            required: true,
            message: "请输入起步价",
            trigger: "blur"
          }
        ],
        startMile: [
          {
            required: true,
            message: "请输入起起步里程",
            trigger: "blur"
          }
        ],
         startMin: [
          {
            required: true,
            message: "请输起步时间",
            trigger: "blur"
          }
        ],
        pricePerMile: [
          {
            required: true,
            message: "请输入计程单价(按公里)",
            trigger: "blur"
          }
        ],
        pricePerMin: [
          {
            required: true,
            message: "请输入计时单价(按分钟)",
            trigger: "blur"
          }
        ],
        increasePrice: [
          {
            required: true,
            message: "请输入单程加价单价",
            trigger: "blur"
          }
        ],
        increasePriceMile: [
          {
            required: true,
            message: "请输入单程加价公里",
            trigger: "blur"
          }
        ],
  
      }
    };
  },
  created() {
    this.getBusinessTypes();
  },

  computed: {},
  methods: {
    handleChange(value) {
      console.log(value);
      //value的值是一个数组，数组里面是省市区码
      //通过CodeToText可以将区域码转为汉字
      // 				console.log(CodeToText[value[0]])
      // 				console.log(CodeToText[value[1]])
      // 				console.log(CodeToText[value[2]])
      // var areaCode='';
      for (var i = 0; i < value.length; i++) {
        //数组的最后一个元素  码传给后台
        // console.log( CodeToText[value[value.length-1]])
        // areaCode=CodeToText[value[value.length-1]];
        this.areaCode = value[value.length - 1];
      }
      //alert(this.areaCode);
      return this.areaCode;
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //alert('submit!');
          //验证通过，发送请求到后台添加，添加成功跳转到运价列表页面
          //alert(TextToCode['北京市']['市辖区'].code);
          console.log(this.areaCode);
          console.log(this.form);
          //1、获取所有的值
          this.$post("pc_fare/addFare", {
            fareFormValue: JSON.stringify(this.form)
          })
            .then(res => {
              //当请求成功，跳转到运价列表页面
              if (res.data.code === 0) {
                this.$router.push({
                  path: "/fare/FareList" //这个组件是在数据库设置的
                });
              }
            })
            .catch(error => {});
        } else {
          console.log("error submit!!");

          return false;
        }
      });
    },
    getBusinessTypes() {
      this.$post("pc_dict/getOrderTypeList", {}).then(result => {
        if (result.data.code === 0) {
          this.businessTypes = result.data.data;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/fare/FareSet.vue